import { useQuery } from "@tanstack/react-query";
import {  Project, ProjectResponse } from "../../../types/project";
import { ApiError } from "../../../types/apiError";
import { getAllProjects, GetAllProjectsParams } from "../api/getAllProjects";

export const useProjectsQuery = (appUserUuid?: string, params?: GetAllProjectsParams) =>
  useQuery<ProjectResponse, ApiError>({
    queryKey: ["projects", appUserUuid, params],
    queryFn: () => {
      if (!appUserUuid) {
        throw new Error("Missing appUserUuid");
      }
      return getAllProjects(appUserUuid, params);
    },
    enabled: Boolean(appUserUuid), 
    placeholderData: (previousData) => previousData,
  });

  